import(/* webpackMode: "eager" */ "/home/jenkins/agent/workspace/cggame123-in-test/frontend/come-frontend-static/src/app/not-found.tsx");
